/**
 * Help-chat escalation draft — boundary contract schema (help-center-chatbot DC-6, BR-27).
 *
 *   POST /landlord/api/help/conversations/:id/escalation
 *
 * The draft prefills the product-support contact form; nothing is sent until the landlord submits it,
 * so the limits are the contact form's own.
 */
import { z } from 'zod';
import { CONTACT_MESSAGE_MAX_CHARS, CONTACT_SUBJECT_MAX_CHARS } from '../support/index.js';
export const EscalationDraftSchema = z.object({
    subject: z.string().max(CONTACT_SUBJECT_MAX_CHARS),
    body: z.string().max(CONTACT_MESSAGE_MAX_CHARS),
});
//# sourceMappingURL=escalation.js.map